import { css, Theme } from '@emotion/react';

declare module '@emotion/react' {
  export interface Theme {
    palette: {
      blankHeaderBackground: string;
      primaryFocused: string;
      borderColor: string;
      borderColor2: string;
      borderColor3: string;
      foundationBlackB500: string;
      foundationBlackB700: string;
      foundationBlackB100: string;
      foundationBlackB30: string;
      foundationBlackB10: string;
      primaryShades1: string;
      primaryShades5: string;
      primaryShades4: string;
      info6: string;
      text6: string;
      text5: string;
      text4: string;
      brandHover: string;
      tertiaryText: string;
      primaryButtonColor: string;
      white: string;
      black: string;
      secondaryTextColor: string;
      primaryTextColor: string;
      brandBackdrop: string;
      brandPrimary: string;
      accordionColor: string;
      pointCardColor: string;
    };
  }
}

export const theme: Theme = {
  palette: {
    blankHeaderBackground: '#FAFAFA',
    primaryFocused: '#EC5013',
    borderColor: '#ECECEC',
    borderColor2: '#487E90',
    borderColor3: '#FAB89E',
    foundationBlackB500: '#464646',
    foundationBlackB700: '#292929',
    foundationBlackB100: '#7D7D7D',
    foundationBlackB30: '#ECECEC',
    foundationBlackB10: '#FAFAFA',
    primaryShades1: '#FEF8F5',
    primaryShades5: '#F46F3B',
    primaryShades4: '#F7956E',
    info6: '#139AB7',
    text6: '#2C2421',
    text5: '#504B49',
    text4: '#867C79',
    tertiaryText: '#867C79',
    brandHover: '#EE622B',
    primaryButtonColor: '#F46F3B',
    white: '#FFFFFF',
    black: '#000000',
    secondaryTextColor: '#504B49',
    primaryTextColor: '#2C2421',
    brandBackdrop: '#FEF8F5',
    brandPrimary: '#F46F3B',
    accordionColor: '#424242',
    pointCardColor: '#07071D',
  },
};

const GlobalStyles = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  * {
    margin: 0;
    font-size: 1em;
  }
  html,
  body {
    height: 100%;
  }
  body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    font-family: 'Manrope', 'Work Sans', sans-serif;
    font-weight: 500;
    color: #464646;
  }
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
  input,
  button,
  textarea,
  select {
    font: inherit;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  #root,
  #__next {
    isolation: isolate;
  }
`;

export default GlobalStyles;
